<template>
  <div class="interventions">
    <transition name="fade" mode="out-in">
      <div class="loading" v-if="start">
        <div class="label">
          <i class="fa fa-cog fa-spin fa-3x fa-fw"></i> <br/>
          {{ message }}
        </div>
      </div>
    </transition>
    <div class="header-intervention" v-if="isNotEmpty(intervention)">
      <div class="header-info" v-if="!intervention.dateDebut">
        {{ formatDate(intervention.dateRdv) }}
      </div>
      <div class="header-info" v-if="intervention.dateDebut">
        {{ diffDate(intervention) }}
      </div>
      <div class="button-content" v-if="!intervention.dateDebut && ([6, 15, 16, 18, 20].indexOf(intervention.typeId) !== -1)">
        <div class="button" v-on:click="startIntervention()">
          <i class="fa fa-play" aria-hidden="true"></i> Démarrer
        </div>
      </div>
      <div class="button-content" v-if="intervention.dateDebut && !intervention.dateFin && ([6, 15, 16, 18, 20].indexOf(intervention.typeId) !== -1)">
        <div class="button" v-on:click="startDebrief()">
          <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Débriefer
        </div>
      </div>
    </div>
    <div class="header-intervention" v-if="!isNotEmpty(intervention)">
      <div class="header-loading" v-html="messageLoading"></div>
    </div>
    <b-container class="intervention-content">
      <b-alert class="cache" variant="warning" show v-if="([6, 15, 16, 18, 20].indexOf(intervention.typeId) === -1)"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Le debriefing est uniquement accessible via la version android d'Aboracco.<br>Si vous rencontrez des difficultés, il faut contacter votre CA.</b-alert>
      <b-alert class="cache" variant="warning" show v-if="cache"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Cache activé <br> Tirez pour synchroniser ou <a href="#" v-on:click="sync">cliquez ici</a></b-alert>
      <div class="etat-box" v-if="isNotEmpty(intervention) && !auditinfra && (intervention.dateDebut || audit)">
        <div v-if="!checkBox" v-html="getEtat(intervention)"></div>
        <div style="font-size: 60px;color: orange;" v-if="checkBox"><i class="fa fa-cog fa-spin"></i></div>
        <div class="label">ÉTAT BOX ( <a v-on:click="getEtatBox()" href="#">Rafraichir</a> )</div>
      </div>
      <div class="information">
        <div class="header">
          <div class="title">
            <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
            <div class="label">RDV</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label">
            <b>Type : </b>{{ intervention.typeReference }}
          </div>
          <div class="label">
            <b>Description : </b>{{ intervention.descr }}
          </div>
          <div class="label">
            <b>Date du RDV : </b>{{ formatDate(intervention.dateRdv) }}
          </div>
          <div class="label">
            <b>RDV Client : </b>
            <i v-if="intervention.rdvClient" class="fa fa-check green-color" aria-hidden="true"></i>
            <i v-if="!intervention.rdvClient" class="fa fa-times red-color" aria-hidden="true"></i>
          </div>

          <!-- Intervention non commencer -->
          <div class="label" v-if="!intervention.dateDebut && !audit">
            <b>NRO : </b>{{ intervention.nro }}
          </div>
          <div class="label" v-if="!intervention.dateDebut && !audit">
            <b>Adresse : </b><a href="">{{ getData('adresse','formePostal') }}</a>
          </div>
          <div class="label" v-if="!intervention.dateDebut && !audit && !auditinfra">
            <b>Abonné : </b>{{ getData('client','nom') !== null ? getData('client','nom') :  getData('cmdAcces','clientNom') }} {{ getData('client','prenom') !== null ? getData('client','prenom') :  getData('cmdAcces','clientPrenom') }}
          </div>
          <div class="label" v-if="!intervention.dateDebut && !audit && !auditinfra">
            <b>Jeton : </b>{{ getData('cmdAcces','jeton') }}
          </div>
          <div class="label" v-if="!intervention.dateDebut && !audit && !auditinfra">
            <b>Commentaire : </b>{{ intervention.commentaire }}
          </div>
          <!-- End Intervention non commencer  -->

          <!-- Intervention -->
          <div class="label" v-if="intervention.dateDebut && auditinfra">
            <b>NRO : </b>{{intervention.nro}}
          </div>
          <div class="label" v-if="intervention.dateDebut && auditinfra">
            <b>PM : </b>{{intervention.nomPm}}
          </div>
          <div class="label" v-if="intervention.dateDebut && !auditinfra">
            <b>ADSL fonctionnel : </b>{{ intervention.hasAdsl }}
          </div>
          <div class="label" v-if="intervention.dateDebut && !auditinfra">
            <b>Status client : </b>{{ intervention.statusClient }}
          </div>
          <div class="label" v-if="intervention.dateDebut">
            <b>Début de l'intervention : </b>{{ formatDate(intervention.dateDebut) }}
          </div>
          <div class="label" v-if="intervention.dateFin">
            <b>Fin de l'intervention : </b>{{ formatDate(intervention.dateFin) }}
          </div>
          <!-- End Intervention -->


        </div>
        <!-- Animation -->
        <div class="content" v-else>
            <div class="shimmer shimmer-label"></div>
            <div class="shimmer shimmer-label"></div>
            <div class="shimmer shimmer-label"></div>
        </div>
        <!-- End animation -->
      </div>
      <!--<div class="information">-->
        <!--<div class="header">-->
          <!--<div class="title">-->
            <!--<i class="fa fa-picture-o" aria-hidden="true"></i>-->
            <!--<div class="label">Photos</div>-->
          <!--</div>-->
        <!--</div>-->
        <!--<div class="content">-->
          <!--<div class="label">-->
            <!--<b>Prendre ou selectionné photo : </b><input id="imageFile" type="file" accept="image/*" multiple/>-->
          <!--</div>-->
          <!--<div class="label" id="previous">-->
            <!--<input type="button" value="Envoi" v-on:click="upload()"/>-->
          <!--</div>-->
    <!--    </div>-->
      <!--</div>-->
      <div class="information" v-if="audit">
        <div class="header">
          <div class="title">
            <i class="fa fa-user-md" aria-hidden="true"></i>
            <div class="label">Technicien</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label">
            <b>Nom : </b>{{ getData('userAudit','nom') }}
          </div>
          <div class="label">
            <b>Prénom : </b>{{ getData('userAudit','prenom') }}
          </div>
          <div class="label">
            <b>Entreprise : </b>{{ getData('userAudit','entreprise') }}
          </div>
          <div class="label">
            <b>Numéro : </b><a :href="'tel:' + getData('userAudit','numero')">{{ getData('userAudit','numero') }}</a>
          </div>
        </div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div class="information" v-if="!auditinfra && (intervention.dateDebut || audit)">
        <div class="header">
          <div class="title">
            <i class="fa fa-user" aria-hidden="true"></i>
            <div class="label">Client</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label">
            <b>Nom : </b>{{ getData('client','nom') !== null ? getData('client','nom') :  getData('cmdAcces','clientNom') }}
          </div>
          <div class="label">
            <b>Prénom : </b>{{ getData('client','prenom') !== null ? getData('client','prenom') :  getData('cmdAcces','clientPrenom') }}
          </div>
          <div class="label">
            <b>Modèle BOX : </b>{{ getData('client','modelBox') }}
          </div>
          <div class="label">
            <b>Adresse : </b><a href="">{{ getData('adresse','formePostal') }}</a>
          </div>
          <div class="label">
            <b>Digicode : </b>{{ getData('client','digicode') }}
          </div>
          <div class="label">
            <b>Résidence : </b>{{ getData('client','residence') }}
          </div>
          <div class="label">
            <b>Batiment : </b>{{ getData('client','batiment') !== null ? getData('client','batiment') : getData('cmdAcces','batiment') }}
          </div>
          <div class="label">
            <b>Etage : </b>{{ getData('client','etage') }}
          </div>
          <div class="label">
            <b>Escalier : </b>{{ getData('client','escalier') }}
          </div>
          <div class="label">
            <b>Porte : </b>{{ getData('client','porte') }}
          </div>
          <div class="label">
            <b>Commentaire : </b>{{ intervention.commentaire }}
          </div>
        </div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div class="information" v-if="!auditinfra && (intervention.dateDebut || audit)">
        <div class="header">
          <div class="title">
            <i class="fa fa-info" aria-hidden="true"></i>
            <div class="label">Commande</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label">
            <b>Jeton : </b>{{ getData('cmdAcces','jeton') }}
          </div>
          <div class="label" v-if="!isNotHoline(intervention)">
            <b >PTO à construire: </b><span style="font-size: 15px;color: red;">{{ getData('cmdAcces','ptoNom') }}</span>
          </div>
          <div class="label" v-if="isNotHoline(intervention)">
            <b >PTO à construire: </b>{{ getData('cmdAcces','ptoNom') }}
          </div>
          <div class="label" v-if="intervention.cmdAcces.ptoCr">
            <b>Dernière PTO connue : </b>{{ getData('cmdAcces','ptoCr') }}
          </div>
          <div class="label">
            <b>PM : </b>{{ getData('cmdAcces','pm') }}
          </div>
          <div class="label">
            <b>NRO : </b>{{ intervention.nro }}
          </div>
        </div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div class="information" v-if="intervention.dateDebut || audit">
        <div class="header">
          <div class="title">
            <i class="fa fa-building-o" aria-hidden="true"></i>
            <div class="label">Information syndic</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label">
            <b>Typologie : </b>{{ getData('infosSyndic','typologie') }}
          </div>
          <div class="label">
            <b>Jarretierage : </b>{{ getData('infosSyndic','jarretierage') }}
          </div>
          <div class="label">
            <b>Hébergement PM : </b>{{ getData('infosSyndic','typeHebergementPm') }}
          </div>
          <div class="label">
            <b>Capa Max PM : </b>{{ getData('infosSyndic','capaMaxPm') }}
          </div>
          <div class="label">
            <b>Type ingenierie : </b>{{ getData('infosSyndic','typeIngenierie') }}
          </div>
          <div class="label">
            <b>Fibre dedié libre : </b>{{ getData('infosSyndic','fibreDedieeLibre') }}
          </div>
          <div class="label">
            <b>Nombre colonnes : </b>{{ getData('infosSyndic','nombreColonnes') }}
          </div>
          <div class="label">
            <b>Type matériel PM : </b>{{ getData('infosSyndic','typeMaterielPm') }}
          </div>
          <div class="label">
            <b>Code immeuble : </b>{{ getData('infosSyndic','codeImmeuble') }}
          </div>
          <div class="label">
            <b>Code acces immeuble : </b>{{ getData('infosSyndic','codeAccesImmeuble') }}
          </div>
          <div class="label">
            <b>Contact immeuble : </b>{{ getData('infosSyndic','contactImmeuble') }}
          </div>
          <div class="label">
            <b>Localisation PM : </b>{{ getData('infosSyndic','localisationPm') }}
          </div>
          <div class="label">
            <b>PM accessible : </b>{{ getData('infosSyndic','pmAccessible') }}
          </div>
          <div class="label">
            <b>Info Clé : </b>{{ getData('infosSyndic','infoCle') }}
          </div>
          <div class="label">
            <b>Code accès sous-sol : </b>{{ getData('infosSyndic','codeAccessSoussol') }}
          </div>
          <div class="label">
            <b>Code local PM : </b>{{ getData('infosSyndic','codeLocalPm') }}
          </div>
          <div class="label">
            <b>Autre : </b>{{ getData('infosSyndic','autre') }}
          </div>
          <div class="label">
            <b>Contact syndic : </b>{{ getData('infosSyndic','contactSyndic') }}
          </div>
        </div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div class="information" v-if="!auditinfra && (intervention.dateDebut || audit)">
        <div class="header danger">
          <div class="title">
            <i class="fa fa-road" aria-hidden="true"></i>
            <div class="label">Route optique</div>
          </div>
        </div>
        <div class="content" v-html="getRop(intervention)" v-if="isNotEmpty(intervention) || audit"></div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div class="information" v-if="intervention.dateDebut && !intervention.dateFin && !auditinfra">
        <div class="header">
          <div class="title">
            <i class="fa fa-qrcode" aria-hidden="true"></i>
            <div class="label">Kit Fibre</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label center" v-if="isNotHoline(intervention)">
            <b>Numéro série </b> <input id="fibre" type="text" v-model="fibre"/>
          </div>
          <div id="video_1"></div>
          <div id="scan_1" class="button" v-on:click="scan(1)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Scan
          </div>
          <div id="closescan_1" class="button hide" v-on:click="CloseScan(1)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Stop scan
          </div>
          <div class="button" v-on:click="pushKitFibre">
            <i class="fa fa-paper-plane-o" aria-hidden="true"></i> Déclarer
          </div>
        </div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div class="information" v-if="intervention.dateDebut && !intervention.dateFin && !auditinfra">
        <div class="header">
          <div class="title">
            <i class="fa fa-qrcode" aria-hidden="true"></i>
            <div class="label">Kit ONU</div>
          </div>
        </div>
        <div class="content" v-if="isNotEmpty(intervention)">
          <div class="label center" v-if="isNotHoline(intervention)">
            <b>Carton </b> <input id="sn1" type="text" v-model="onu.sn1"/>
          </div>
          <div id="video_2"></div>
          <div id="scan_2" class="button" v-on:click="scan(2)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Scan
          </div>
          <div id="closescan_2" class="button hide" v-on:click="CloseScan(2)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Stop scan
          </div>
          <div class="label center" v-if="isNotHoline(intervention)">
            <b>ONU </b> <input id="sn2" type="text" v-model="onu.sn2"/>
          </div>
          <div id="video_3"></div>
          <div id="scan_3" class="button" v-on:click="scan(3)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Scan
          </div>
          <div id="closescan_3" class="button hide" v-on:click="CloseScan(3)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Stop scan
          </div>
          <div class="label center" v-if="isNotHoline(intervention)">
            <b>SFP </b> <input id="sn3" type="text" v-model="onu.sn3"/>
          </div>
          <div id="video_4"></div>
          <div id="scan_4" class="button" v-on:click="scan(4)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Scan
          </div>
          <div id="closescan_4" class="button hide" v-on:click="CloseScan(4)">
            <i class="fa fa-barcode" aria-hidden="true"></i> Stop scan
          </div>
          <div class="button" v-on:click="pushOnu">
            <i class="fa fa-paper-plane-o" aria-hidden="true"></i> Déclarer
          </div>
          <div id="interactive" class="viewport hide">
            <video autoplay="true" preload="auto" src="">
            </video>
          </div>
        </div>
        <div class="content" v-else>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
          <div class="shimmer shimmer-label"></div>
        </div>
      </div>
      <div v-if="intervention.dateDebut && !intervention.dateFin && auditinfra"></div>
    </b-container>
  </div>
</template>

<script>
import PullToRefresh from '../assets/js/pulltorefresh'
import moment from 'moment'
import Quagga from 'quagga' // ES6
moment.locale('fr')
export default {
  name: 'Interventions',
  data () {
    return {
      intervention_id: null,
      backLabel: 'Retour',
      cache: false,
      messageLoading: '<i class="fa fa-refresh fa-spin"></i> Récupération de l\'intervention',
      intervention: {},
      fibre: '',
      onu: {
        sn1: '',
        sn2: '',
        sn3: ''
      },
      scanChoix: null,
      request: false,
      start: false,
      message: null,
      audit: false,
      auditconstatation: false,
      auditinfra: false,
      checkBox: false,
      state: {
        inputStream: {
          type: 'LiveStream',
          constraints: {
            width: {min: 100},
            height: {min: 100},
            aspectRatio: {min: 1, max: 100},
            facingMode: 'environment' // or "user" f  or the front camera
          }
        },
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        numOfWorkers: (navigator.hardwareConcurrency ? navigator.hardwareConcurrency : 4),
        decoder: {
          readers: ['code_128_reader']
        },
        locate: true
      },
      activate: false
    }
  },
  methods: {
    formatDate: function (date) {
      if (date === undefined) {
        return ''
      }
      return moment(date).format('dddd DD MMMM à HH:mm')
    },
    scanInit: function () {
      Quagga.init(this.state, function (err) {
        if (err) {
          console.log(err)
          return
        }
        Quagga.start()
      })
    },
    scan: function (choix) {
      this.scanChoix = choix
      if (this.activate) {
        return this.$toast.bottom('Merci de terminer ou stopper l\'autre scan en cours :)')
      }
      let _this = this
      _this.activate = true
      $('#interactive').appendTo('#video_' + choix).removeClass('hide')
      $('#closescan_' + choix).removeClass('hide')
      $('#scan_' + choix).addClass('hide')
      this.scanInit()
      Quagga.onProcessed(function (result) {
        let drawingCtx = Quagga.canvas.ctx.overlay
        let drawingCanvas = Quagga.canvas.dom.overlay

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')))
            result.boxes.filter(function (box) {
              return box !== result.box
            }).forEach(function (box) {
              Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: 'green', lineWidth: 2})
            })
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: '#00F', lineWidth: 2})
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3})
          }
        }
      })
      Quagga.onDetected(function (result) {
        if (result.codeResult.code) {
          _this.activate = false
          if (_this.scanChoix === 1) {
            _this.fibre = result.codeResult.code
            $('#fibre').val(result.codeResult.code)
          }
          if (_this.scanChoix === 2) {
            _this.onu.sn1 = result.codeResult.code
            $('#sn1').val(result.codeResult.code)
          }
          if (_this.scanChoix === 3) {
            _this.onu.sn2 = result.codeResult.code
            $('#sn2').val(result.codeResult.code)
          }
          if (_this.scanChoix === 4) {
            _this.onu.sn3 = result.codeResult.code
            $('#sn3').val(result.codeResult.code)
          }
          Quagga.stop()
          $('#interactive').addClass('hide')
          $('#closescan_' + _this.scanChoix).addClass('hide')
          $('#scan_' + _this.scanChoix).removeClass('hide')
        }
      })
    },
    CloseScan: function (choix) {
      $('#interactive').addClass('hide')
      $('#closescan_' + choix).addClass('hide')
      $('#scan_' + choix).removeClass('hide')
      this.activate = false
      if (Quagga) {
        Quagga.stop()
      }
    },
    pushKitFibre: function () {
      if (this.request) {
        return this.$toast.bottom('Requète en cours')
      }
      if (this.fibre === '') {
        return this.$toast.bottom('Merci de saisir une valeur')
      }
      this.request = true
      let data = {}
      data.jeton = this.intervention.jeton
      data.kitBarcode = this.fibre
      this.$http.post('intervention/barcodeKit', JSON.stringify(data)).then(response => {
        this.request = false
        if (response.status === 201) {
          return this.$toast.bottom('KitFibre inséré')
        }
        if (response.status === 202) {
          return this.$toast.bottom(response.body.message)
        }
        return this.$toast.bottom('Une erreur est survenue')
      })
    },
    pushOnu: function () {
      if (this.request) {
        return this.$toast.bottom('Requète en cours')
      }
      if (this.onu.sn1 === '' || this.onu.sn2 === '' || this.onu.sn3 === '') {
        return this.$toast.bottom('Merci de saisir une valeur dans tous les champs "Kit ONU"')
      }
      this.request = true
      let data = {}
      data.jeton = this.intervention.jeton
      data.cartonBarcode = this.onu.sn1
      data.onuBarcode = this.onu.sn2
      data.sfpBarcode = this.onu.sn3

      this.$http.post('intervention/barcodeONU', JSON.stringify(data)).then(response => {
        this.request = false
        if (response.status === 201) {
          return this.$toast.bottom('ONU inséré')
        }
        if (response.status === 202) {
          return this.$toast.bottom(response.body.message)
        }
        return this.$toast.bottom('Une erreur est survenue')
      })
    },
    getEtat: function (intervention) {
      let html = ''
      if (intervention.etat === 'OK') {
        html += '<div style="font-size: 60px;color: green;">OK</div>'
      } else if (intervention.etat === 'NOK') {
        html += '<div style="font-size: 60px;color: red;">NOK</div>'
      } else {
        html += '<div style="font-size: 60px;color: orange;">-</div>'
      }
      return html
    },
    startDebrief: function () {
      if (this.intervention.etat === null && !this.auditinfra) {
        this.start = true
        this.message = 'Ping BOX en cours'
        this.getEtatBox(this.startDebrief)
        return
      }
      this.start = true
      this.message = 'Récupération du debrief'
      let typeId = null
      for (let i in this.intervention['typeDebrief']) {
        if (this.intervention['typeDebrief'][i]['nom'] === this.intervention.etat) {
          typeId = this.intervention['typeDebrief'][i]['id']
        }
      }
      if (this.audit) {
        typeId = 45
        if (this.intervention.typeId === 20) {
          typeId = 51
        }
      }
      if (this.intervention.typeId === 15 || this.intervention.typeId === 16) {
        typeId = 48
      }
      if (this.auditconstatation) {
        typeId = 50
      }
      if (!typeId) {
        this.start = false
        return this.$toast.bottom('Une erreur est survenue lors de la récuperation du debrief 1/2')
      }
      let _this = this
      this.$http.get('recap/' + typeId).then(response => {
        this.response = response.json().then((data) => {
          localStorage.setItem('debrief_' + this.intervention_id, JSON.stringify(data))
          if (this.auditinfra && !this.auditconstatation) {
            _this.$getItem(this.intervention_id, function (err, values) {
              if (err) {
                return
              }
              if (!values.pm || !values.pm.length) {
                _this.$http.get('intervention/' + _this.intervention_id + '/pm').then(response => {
                  if (!response.body.length) {
                    _this.$toast.bottom('Aucune position n\'a été trouvée sur ce PM')
                  }
                  values.pm = response.body
                  values.pm.forEach(pm => {
                    pm.complete = false
                  })
                  _this.$setItem(_this.intervention_id, values, function (err, value) {
                    if (err) {
                      alert(err)
                    }
                    _this.$router.push('/intervention/' + _this.intervention_id + '/auditpm')
                  })
                })
              } else {
                _this.$router.push('/intervention/' + _this.intervention_id + '/auditpm')
              }
            })
          } else if (this.auditconstatation) _this.$router.push('/intervention/' + _this.intervention_id + '/auditconstatation')
          else _this.$router.push('/intervention/' + _this.intervention_id + '/debrief')
          this.start = false
        })
      }, (response) => {
        this.start = false
        this.$toast.bottom('Une erreur est survenue lors de la récuperation du debrief 2/2')
      })
    },
    getEtatBox: function (callback) {
      this.checkBox = true
      let data = {}
      data.pto = this.intervention.cmdAcces.ptoNom
      data.intervention_id = this.intervention.interventionId
      this.$http.get(`intervention/${data.intervention_id}/etatbox`, JSON.stringify(data)).then(response => {
        this.response = response.json().then((data) => {
          if (data.etat_box) {
            this.intervention.etat = 'OK'
          } else {
            this.intervention.etat = 'NOK'
          }
          this.saveToCache()
          if (callback !== undefined) {
            callback()
          }
          this.checkBox = false
        })
      }, (response) => {
        if (response.status === 429) {
          this.$toast.bottom(response.body.message)
        } else {
          this.$toast.bottom('Une erreur est survenue lors du ping de la box')
        }
        this.checkBox = false
      })
    },
    isNotEmpty: function (intervention) {
      return Object.keys(intervention).length === 0 ? 0 : 1
    },
    isNotHoline: function (pto) {
      return pto.cmdAcces.ptoNom === 'Reprov obligatoire' ? 0 : 1
    },
    startIntervention: function () {
      this.start = true
      this.$http.get('intervention/' + this.intervention_id + '/action/start').then(response => {
        if (response.status === 202) {
          this.$toast.bottom(response.body.message)
        }
        this.response = response.json().then((data) => {
          this.intervention.dateDebut = data.dateDebut
          this.saveToCache(this.intervention_id, this.intervention)
          this.start = false
        })
      }, (response) => {
        this.start = false
      })
    },
    diffDate: function (intervention) {
      let bdate = new Date()
      if (intervention.dateFin !== null) {
        bdate = intervention.dateFin
      }
      let a = moment(bdate)
      let b = moment(intervention.dateDebut)
      let diff = a.diff(b)
      let duration = moment.duration(diff)

      if (duration.days() !== 0) {
        return 'Durée : ' + duration.days() + 'j ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
      }

      return 'Durée : ' + duration.hours() + 'h ' + duration.minutes() + 'm ' + duration.seconds() + 's'
    },
    goBackIntervention: function () {
      this.$router.go(-1)
    },
    getData: function (key, value) {
      if (this.intervention[key] !== undefined) {
        if (this.intervention[key][value] !== undefined) {
          return this.intervention[key][value]
        }
      }
    },
    getRop: function (intervention) {
      let html = ''

      if (intervention.cmdAcces === undefined) {
        return ''
      }
      if (Object.keys(intervention.cmdAcces).length === 0) {
        return ''
      }
      if (Object.keys(intervention.cmdAcces['ropData']).length === 0) {
        return ''
      }
      html += '<div style="font-size: 16px; margin-bottom: 5px; border-bottom: 0.5px solid #666"><b><i class="fa fa-building-o" aria-hidden="true"></i> Verticalité</b></div>'
      for (let i in intervention.cmdAcces['ropData']['verticalite']['common']) {
        html += '<div style="font-size: 13px;"><b>' + i + ' : </b>' + intervention.cmdAcces['ropData']['verticalite']['common'][i] + '</div>'
      }
      html += '<div style="padding: 10px">'
      for (let i = 1; i <= 4; i++) {
        if (intervention.cmdAcces['ropData']['verticalite']['fibre' + i] === undefined) {
          continue
        }

        if (intervention.cmdAcces['ropData']['verticalite']['fibre' + i]['fibreOperateur'] === 'FREE') {
          html += '<div style="font-size: 14px; margin-bottom: 5px;margin-top: 5px;color:rgb(230, 68, 68); "><b> <i class="fa fa-chevron-right" aria-hidden="true"></i> Fibre ' + i + ' - FREE</b></div>'
        } else {
          html += '<div style="font-size: 14px; margin-bottom: 5px;margin-top: 5px;"><b> <i class="fa fa-chevron-right" aria-hidden="true"></i> Fibre ' + i + '</b></div>'
        }
        delete intervention.cmdAcces['ropData']['verticalite']['fibre' + i]['fibreOperateur']

        for (let key in intervention.cmdAcces['ropData']['verticalite']['fibre' + i]) {
          html += '<div style="font-size: 13px;"><b>' + key + ' : </b>' + intervention.cmdAcces['ropData']['verticalite']['fibre' + i][key] + '</div>'
        }
      }
      html += '</div>'

      html += '<div style="font-size: 16px; margin-bottom: 5px; border-bottom: 0.5px solid #666"><b><i class="fa fa-road" aria-hidden="true"></i> Horizontalité</b></div>'
      for (let i in intervention.cmdAcces['ropData']['horizontalite']) {
        let label = null
        if (i === 'backbone') {
          label = 'Backbone'
        }
        if (i === 'connecteurCad') {
          label = 'Connecteur CAD'
        }
        if (i === 'positionBaie') {
          label = 'Position baie'
        }
        if (i === 'breakout') {
          label = 'Breakout'
        }
        if (i === 'baieActive') {
          label = 'Baie active'
        }

        html += '<div style="font-size: 13px;"><b>' + label + ' : </b>' + intervention.cmdAcces['ropData']['horizontalite'][i] + '</div>'
      }
      return html
    },
    saveToCache: function () {
      this.$setItem(this.intervention_id, this.intervention, function (err, values) {
        if (err) {
          alert(err)
        }
      })
    },
    sync: function () {
      this.getIntervention()
    },
    getIntervention: function (cb) {
      this.$http.get('intervention/' + this.intervention_id).then(response => {
        this.response = response.json().then((data) => {
          this.intervention = data
          this.cache = false
          this.saveToCache()
          this.backLabel = 'Production'
          if (data.typeId === 2 || data.typeId === 4) {
            this.backLabel = 'PostProduction / SAV'
          }
          if (this.intervention.userAudit) {
            this.audit = true
          }
          if (data.typeId === 15 || data.typeId === 16 || data.typeId === 18) {
            this.auditinfra = true
          }
          if (data.typeId === 18) {
            this.auditconstatation = true
          }
          if (typeof cb === 'function') {
            cb()
          }
        })
      }, (response) => {
        if (typeof cb === 'function') {
          cb()
        }
        if (!this.cache) {
          this.$toast.bottom('Une erreur est survenue lors de la récupération')
          this.messageLoading = '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Récupération impossible'
        }
      })
    }
  },
  mounted: function () {
    this.intervention_id = this.$route.params.intervention_id
    let _this = this
    PullToRefresh.init({
      mainElement: '.intervention-content',
      onRefresh: function (cb) { _this.getIntervention(cb) }
    })
    this.$getItem(this.intervention_id, function (err, values) {
      if (err) {
        return
      }
      if (values === null) {
        _this.getIntervention()
        return
      }

      _this.cache = true
      _this.intervention = values
      if (_this.intervention.userAudit) {
        _this.audit = true
      }
      if (_this.intervention.typeId === 15 || _this.intervention.typeId === 16 || _this.intervention.typeId === 18) {
        _this.auditinfra = true
      }
      if (_this.intervention.typeId === 18) {
        _this.auditconstatation = true
      }
    })
    window.scrollTo(0, 0)
  }
}
</script>
<style scoped>
.intervention-content{
  padding-top: 15px;
}
.header-loading{
  width: 100%;
  text-align: center;
  padding-top: 74px;
  color: white;
}
.header-info{
  display: inline-block;
  position: absolute;
  left: 16px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 71px;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;
}
.information{
  position: relative;
  background: #ffffff;
  margin-bottom: 10px;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  color: #444;
  padding: 20px 10px 10px;
}
.etat-box{
  width: 100%;
  position: relative;
  margin-bottom: 10px;
  text-align: center;
}
.etat-box > .statut.green{
  color: green;
}
.etat-box > .label{
  color: #777;
  font-size: 14px;
}
.etat-box > .statut{
  font-size: 60px;
  line-height: 1.3;
}
.information > .header{
  background-color: rgb(230, 68, 68);
  padding: 5px;
  padding-left: 10px;
  position: absolute;
  top:0;
  right: 0;
  left: 0;
  color: white;
  font-size: 14px;
}
.information > .header > .title > .fa {
  width: 15px;
  text-align: center;
}
.information > .header > .title > .label {
  display: inline-block;
}
.information > .content{
  margin-top: 25px;
}
.information > .content > .label{
  font-size: 13px;
}
.button-content > .button{
  display: inline-block;
  position: absolute;
  right: 16px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  top: 71px;
  background-color: rgb(230, 68, 68) !important;
  border-color: rgb(230, 68, 68) !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0.2rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}
.loading{
  position: fixed;
  text-align: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.7);
  z-index: 9999;
  color: white;
  top: 55px;
}
.loading > .label{
  padding-top: 35vh;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.information input {
  text-align: center;
  padding: .48rem .75rem;
  font-size: 1rem;
  line-height: 1;
  color: #464a4c;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: inherit;
  background-color: #fff;
  background-image: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-clip: padding-box;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: .25rem;
  margin-top: 0px;
  -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
  transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
}
.label.center {
  text-align: center;
  padding-bottom: 5px;
  padding-top: 5px ;
}
.information .button {
  color: rgb(230, 68, 68);
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 6px;
  background-color: white;
  border:1px solid rgb(230, 68, 68) !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0.2rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
}
.hide{
  display: none;
}

#interactive.viewport {
  width: 100%;
  height: 300px;
  overflow: hidden;
}


#interactive.viewport canvas, video {
  margin-top: -50px;
  margin-left: -100px;
  width: 168%;
  height: 320px;
}

#interactive.viewport canvas.drawingBuffer, video.drawingBuffer {
}
</style>



// WEBPACK FOOTER //
// src/components/Intervention.vue